import { inject } from "@angular/core";
import { UrlTree, Router } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { PiaContextService } from "../../shared/pia-api/pia-context.service";
import { PiaLocaleService } from "../../shared/services/pia-locale.service";

export async function defaultProductInfoRedirect(): Promise<UrlTree> {
  const contextService = inject(PiaContextService);
  const router = inject(Router);
  const piaLocale = inject(PiaLocaleService);

  // Seed PIA's country + product language from the profile selection so bare
  // /pia entry respects what the user picked in the profile menu instead of
  // static defaults. PiaLocaleService maps both onto what PIA actually offers.
  const { countryID, languageID } = await firstValueFrom(
    piaLocale.resolveLocale(),
  );
  const latestYear = await firstValueFrom(
    contextService.getLatestYearByCountryIdAndLanguageId({
      countryID,
      languageID,
    }),
  );
  return router.createUrlTree([
    "pia",
    countryID,
    languageID,
    latestYear,
    "product-info",
  ]);
}
